import { openBlock as t, createElementBlock as e, createStaticVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}, a = /* @__PURE__ */ o('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#guest_svg__a)"><path d="M4.622 5.623a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M9 11.25a4.375 4.375 0 1 0-8.75 0v1.875h1.875l.625 6.25H6.5l.625-6.25H9z" clip-rule="evenodd"></path><path d="M12.122 16.874V10H16.5c.69 0 1.25.56 1.25 1.25v5.625c0 .69-.56 1.25-1.25 1.25h-3.125"></path><path d="M12.122 19.373a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" clip-rule="evenodd"></path><path d="M12.122 4.998v5"></path></g><defs><clipPath id="guest_svg__a"><path fill="currentColor" d="M0 0h18v20H0z"></path></clipPath></defs>', 2), c = [
  a
];
function l(n, d) {
  return t(), e("svg", r, [...c]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
